import { ViewModel,View } from "binder"
import { IExecutablePart, IExecutablePartVisitor } from "../executablePart";
import  { JsCodeView } from "./jsCode-view"

export class JsCodeViewModel extends ViewModel implements IExecutablePart{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new JsCodeView();
    }
    public getTypeId(): string {
        return "VM-F6EE1EFC-61F2-480D-979E-8153936B53C8"
    }

    accept(visitor: IExecutablePartVisitor, parameter: any) {
        return visitor.VisitJsCode(this,parameter);
    }
    
    public set code(v: string) { this._code = v; } public get code(): string { return this._code;} private _code: string;
    
}
